import React from "react";
import { Link } from "react-router-dom";

// Styles
import styles from "./DashboardMain.module.css";

// Images
import ClockIcon from "./../../../assets/img/DashboardICons/ClockIcon.svg";
import arrowBlue from "./../../../assets/img/DashboardICons/ArrowLeftBlue.svg";
import addIconBlue from "./../../../assets/img/DashboardICons/AddIconBlue.svg";
import folderGreenIcon from "./../../../assets/img/DashboardICons/folderGreenIcon.svg";
import peopleGreenIcon from "./../../../assets/img/DashboardICons/peopleGreenIcon.svg";

const DashboardMainFiles = ({ dashboardData, personnelCount, userCount, dashboardFileData }) => {
  return (
    <div dir="rtl" className={`mt-4 pt-3 mx-md-4 px-md-2 px-3 d-flex justify-content-between flex-wrap`}>
      <div className={`ms-md-3 ms-sm-0 p-md-4 p-3 text-end ${styles.total_latestFiles_box}`}>
        <div className={`d-flex align-items-start justify-content-between`}>
          <h5 className={`mx-md-0 mx-1 ${styles.total_title_dashboardMain_box}`}> آخرین فایل ها افزوده شده </h5>
          <Link to="/FileManagement" className={`mx-md-0 mx-1 ${styles.total_link_more_box}`}>
            {" "}
            مشاهده همه{" "}
          </Link>
        </div>

        {dashboardFileData?.map(latestFile => (
          <div key={latestFile.id} className={`d-flex align-items-center justify-content-between mt-3 ${styles.total_filesInfo_box}`}>
            <p className={`m-0 ${styles.title_filesInfo_box}`}> {latestFile.title?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])} </p>
            <div>
              <img src={ClockIcon} alt="time-upload-icon" width="17" />
              <span className={`pe-1 ${styles.time_title_filesInfo_box}`}> {latestFile.createDate?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])} </span>
            </div>
            <Link
              to={{
                pathname: `/card-detail/${latestFile.id}`,
                state: {
                  state: latestFile,
                  isArchive: false,
                },
              }}>
              <img src={arrowBlue} alt="arrow-left-blue" width="18" />
            </Link>
          </div>
        ))}
      </div>

      <div className={`me-md-3 me-sm-0 ${styles.total_staffFiles_box}`}>
        <Link to="/add-new-file" className={`w-100 text-center d-block ${styles.total_buttonCreateFile_box}`}>
          <img className={`px-3`} src={addIconBlue} alt="add-icon-blue" />
          <Link to="/add-new-file" style={{ color: "#21409a" }} className={`border-0 bg-transparent ${styles.button_CreateFile}`}>
            {" "}
            ایجاد فایل جدید{" "}
          </Link>
        </Link>

        <div className={`my-4 d-flex align-items-start justify-content-start ${styles.total_counts_box}`}>
          <div className={`bg-white p-2 d-flex align-items-center justify-content-center ${styles.total_icons_counts_box}`}>
            <img src={folderGreenIcon} alt="folder-green-icon" />
          </div>
          <div className={`me-4 text-right`}>
            <h5 className={`pt-1 pb-1 ${styles.total_title_counts_box}`}> تعداد فایل ها </h5>
            <h4 className={`mb-0 ${styles.total_subTitle_counts_box}`}>{dashboardData?.estateCount?.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}</h4>
          </div>
          <div className="me-auto">
            <div className="d-flex justify-content-start align-items-center">
              <i className={`d-inline-block ${styles.total_circle_file_box}`} style={{ backgroundColor: "#127442" }}></i>
              <span className={`pe-2 text-right ${styles.total_title_file_box}`}> فعال </span>
              <span className={`ps-1 text-right ${styles.total_count_file_box}`}>
                {dashboardData?.activeCount?.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}
              </span>
            </div>
            <div className="my-1 py-1 d-flex justify-content-start align-items-center">
              <i className={`d-inline-block ${styles.total_circle_file_box}`} style={{ backgroundColor: "#E7CF00" }}></i>
              <span className={`pe-2 text-right ${styles.total_title_file_box}`}> آرشیو </span>
              <span className={`ps-1 text-right ${styles.total_count_file_box}`}>
                {dashboardData?.archivedCount?.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}
              </span>
            </div>
            <div className="my-1 py-1 d-flex justify-content-start align-items-center">
              <i className={`d-inline-block ${styles.total_circle_file_box}`} style={{ backgroundColor: "#127442" }}></i>
              <span className={`pe-2 text-right ${styles.total_title_file_box}`}> پیش نویس </span>
              <span className={`ps-1 text-right ${styles.total_count_file_box}`}>
                {dashboardData?.draftCount?.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}
              </span>
            </div>
            <div className="d-flex justify-content-start align-items-center">
              <i className={`d-inline-block ${styles.total_circle_file_box}`} style={{ backgroundColor: "#E7CF00" }}></i>
              <span className={`pe-2 text-right ${styles.total_title_file_box}`}> درانتظار تایید </span>
              <span className={`ps-1 text-right ${styles.total_count_file_box}`}>
                {dashboardData?.pendingCount?.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}
              </span>
            </div>
            <div className="d-flex justify-content-start align-items-center">
              <i className={`d-inline-block ${styles.total_circle_file_box}`} style={{ backgroundColor: "#E70000" }}></i>
              <span className={`pe-2 text-right ${styles.total_title_file_box}`}> رد شده </span>
              <span className={`ps-1 text-right ${styles.total_count_file_box}`}>
                {dashboardData?.rejectedCount?.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}
              </span>
            </div>
          </div>
        </div>

        <div className={`d-flex align-items-start justify-content-start ${styles.total_counts_box}`}>
          <div className={`bg-white p-2 d-flex align-items-center justify-content-center ${styles.total_icons_counts_box}`}>
            <img src={peopleGreenIcon} alt="people-green-icon" />
          </div>
          <div className={`me-4 text-right`}>
            <h5 className={`pt-1 pb-1 ${styles.total_title_counts_box}`}> تعداد پرسنل </h5>
            <h4 className={`mb-0 ${styles.total_subTitle_counts_box}`}>{personnelCount?.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}</h4>
          </div>
          <div className="d-flex align-self-end me-auto">
            <Link to="/staff-managment-colleagues-info" style={{ color: "#21409a" }}>
              مشاهده
              <img className="p-2" src={arrowBlue} alt="arrow-left-blue" width="29" />
            </Link>
          </div>
        </div>
        <div className={`d-flex align-items-start justify-content-start mt-4 ${styles.total_counts_box}`}>
          <div className={`bg-white p-2 d-flex align-items-center justify-content-center ${styles.total_icons_counts_box}`}>
            <img src={peopleGreenIcon} alt="people-green-icon" />
          </div>
          <div className={`me-4 text-right`}>
            <h5 className={`pt-1 pb-1 ${styles.total_title_counts_box}`}> تعداد کاربران </h5>
            <h4 className={`mb-0 ${styles.total_subTitle_counts_box}`}>{userCount?.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}</h4>
          </div>
          <div className="d-flex align-self-end me-auto">
            <Link to="/user-managment-info" style={{ color: "#21409a" }}>
              مشاهده
              <img className="p-2" src={arrowBlue} alt="arrow-left-blue" width="29" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardMainFiles;
